var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    opacity: 0.5,
    clipPath: "url(#clip0_156_1123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2863 19.2564H18.572C17.8142 19.2564 17.0875 18.9554 16.5517 18.4196C16.0159 17.8838 15.7148 17.157 15.7148 16.3993C15.7148 17.157 15.4138 17.8838 14.878 18.4196C14.3422 18.9554 13.6155 19.2564 12.8577 19.2564C12.0999 19.2564 11.3732 18.9554 10.8374 18.4196C10.3016 17.8838 10.0006 17.157 10.0006 16.3993C10.0006 17.157 9.69954 17.8838 9.16372 18.4196C8.6279 18.9554 7.90118 19.2564 7.14342 19.2564C6.38565 19.2564 5.65893 18.9554 5.12311 18.4196C4.58729 17.8838 4.28627 17.157 4.28627 16.3993C4.28627 17.157 3.98525 17.8838 3.44943 18.4196C2.91362 18.9554 2.18689 19.2564 1.42913 19.2564H0.714844M14.2863 13.5421C13.5505 12.6476 12.6258 11.9272 11.5785 11.4326C10.5312 10.9379 9.38735 10.6814 8.22913 10.6814C7.07091 10.6814 5.92706 10.9379 4.87977 11.4326C3.83248 11.9272 2.90774 12.6476 2.17199 13.5421",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.2837 10.7565C9.36942 7.52788 10.3551 4.58502 12.498 3.52788M8.22656 0.813592C9.15261 0.631246 10.1133 0.811108 10.9107 1.31611C11.708 1.8211 12.2813 2.61275 12.5123 3.52788",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.7286 4.05612C17.0711 3.34616 16.177 2.90068 15.2142 2.80335C14.2515 2.70602 13.2863 2.96355 12.5 3.52755",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.25781 5.05648C7.8176 4.23177 8.64734 3.62797 9.60424 3.34898C10.5612 3.06999 11.5854 3.13326 12.5007 3.52791C13.4188 3.75244 14.2136 4.32501 14.7174 5.12469C15.2212 5.92438 15.3945 6.88856 15.2007 7.81362",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_1123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.dda25750054f25f373c390eb5ca4cc38.svg";
export { ForwardRef as ReactComponent };